import { render, staticRenderFns } from "./ModalRulesFaceDetection.vue?vue&type=template&id=a1106bda&scoped=true&"
import script from "./ModalRulesFaceDetection.vue?vue&type=script&lang=js&"
export * from "./ModalRulesFaceDetection.vue?vue&type=script&lang=js&"
import style0 from "./ModalRulesFaceDetection.vue?vue&type=style&index=0&id=a1106bda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1106bda",
  null
  
)

export default component.exports